import { Button } from "~/shared";
import { tw } from "~/utils";

type DeleteConfirmationModalProps = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteScheduleConfirmation = ({
  show,
  onClose,
  onConfirm,
}: DeleteConfirmationModalProps) => {
  if (!show) return null;

  return (
    <div
      className="pt-68 absolute inset-0 z-20 flex items-start justify-center"
      onClick={onClose}
    >
      <div
        className={tw(
          "w-full max-w-sm rounded-md bg-white shadow-xl",
          "flex flex-col gap-6 p-6",
        )}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex flex-col gap-2">
          <h3 className="text-dark-blue-gray text-lg font-bold leading-6">
            Delete file?
          </h3>
          <p className="text-dark-blue-gray leading-6">
            Are you sure you want to delete this schedule template? This action
            cannot be undone.
          </p>
        </div>

        <div className="flex gap-4">
          <Button
            variant="outline"
            size="sm"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>

          <Button size="sm" onClick={onConfirm} className="flex-1">
            Yes, Delete It
          </Button>
        </div>
      </div>
    </div>
  );
};
